var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_263_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32136 12.3748C1.06078 12.3748 0.806061 12.3155 0.589413 12.2044C0.372764 12.0934 0.203911 11.9355 0.104198 11.7509C0.00448461 11.5663 -0.0216104 11.3631 0.0292113 11.1671C0.0800331 10.9711 0.20549 10.791 0.389721 10.6497L6.31952 6.10182C6.56664 5.91236 6.90175 5.80592 7.25116 5.80592C7.60058 5.80592 7.93569 5.91236 8.1828 6.10182L12.5221 9.42983L18.838 4.58588C18.9596 4.48935 19.105 4.41236 19.2657 4.35939C19.4265 4.30643 19.5994 4.27855 19.7744 4.27738C19.9493 4.27622 20.1229 4.30179 20.2848 4.3526C20.4468 4.40342 20.5939 4.47846 20.7176 4.57335C20.8413 4.66824 20.9392 4.78108 21.0054 4.90528C21.0717 5.02949 21.105 5.16256 21.1035 5.29676C21.102 5.43095 21.0656 5.56356 20.9966 5.68686C20.9275 5.81016 20.8271 5.92168 20.7013 6.01491L13.4537 11.5734C13.2066 11.7628 12.8715 11.8693 12.5221 11.8693C12.1727 11.8693 11.8376 11.7628 11.5905 11.5734L7.25116 8.24537L2.253 12.0787C2.00593 12.2682 1.67082 12.3747 1.32136 12.3748Z",
    fill: "#26A677"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_1643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.0837,
    height: 16.1701,
    fill: "white",
    transform: "translate(0.00390625 0.248047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/lineChart.1b261e2900fe78f22838c419b5d324a7.svg";
export { ForwardRef as ReactComponent };